<template>
  <div class="start-exam">
    <div class="examheader">
      <div class="person">
        <div class="photoHov">
          <img src="../assets/img/tou.png" width="65" height="86">
        </div>
        <div class="perMes">
          <label>账户：{{ account }}</label>
          <label>姓名：{{ name }}</label>
        </div>
        <div class="tit">{{ detailObj.ExamPaperName }}</div>
        <div style="width: 550px; float: right; height: 80px;">
          <span class="skip" id="handin_btn" @click="skip" v-if="showState">跳过</span>
          <input type="button" value="交卷" class="sub" id="handin_btn" @click="comitExam">
          <span class="timer">
            剩余时间：
            <label class="hourTotal">{{ hour }}</label>:
            <label class="minuteTotal">{{ minute }}</label>:
            <label class="secondTotal">{{ second }}</label>
          </span>
        </div>
      </div>
    </div>
    <State :style="{ display: showState ? '' : 'none' }"></State>
    <div class="exammain" :style="{ display: !showState ? '' : 'none' }">
      <div class="mainLeft">
        <div class="title" v-for="(item, index) in leftList" :key="index" :id="'part' + index">
          <p class="titPart" :style="{ color: item.isanswer ? '#b5b5b5' : '' }">{{ item.ExamPartName }}</p>
          <div style="padding-top: 10px;display: block;">
            <a ref="allList" href="javascript:;" :class="{ 'mark': it.ismark, 'yellow': it.isclick, 'blue': it.isanswer, }" class="myitem" :id="'part' + index + '_ques' + num" @click="SelectQues(item, index, it,num)" v-for="(it, num) in item.list" :key="num">{{ num + 1 }}</a>
          </div>
        </div>
      </div>
      <div class="mainRight" v-if="activePart">
        <div class="myform" :style="{ display: !showChoose ? 'block' : 'none' }">
          <div class="ti anli">
            <div class="part">
              <span id="mytitle" v-if="activePart.ExamItemList">{{ activePart.ExamPartName }} 共{{ leftList[activePartIndex].list.length }}题，作答时限{{ activePartIndex == 0 && detailObj.IsForcedReading ? activePart.ExamTime - 2 : activePart.ExamTime }}分钟<br></span>
              <span class="completeBtn" @click="completeClick" v-if="activePart.ExamPartName != '第1部分：知觉速度与准确性'">
                完成本部分试题
              </span>
              <span class="mytime2">
                本部分剩余时间
                <label class="hourPart">{{ h }}</label>:
                <label class="minutePart">{{ m }}</label>:
                <label class="secondPart">{{ s }}</label>
              </span>
            </div>
            <div class="subject" style="height: calc(100% - 75px);">
              <div class="skill">
                <a v-if="activePart.ExamPartName&&(activePart.ExamPartName.indexOf('知觉速度与准确性')!==-1||activePart.ExamPartName.indexOf('资料分析')!==-1)" href="javascript:;" class="row" @click="isdisplay = !isdisplay"></a>
                <a href="javascript:;" class="NoStress" @click="cancelhlightSelectedText">取消强调</a>
                <a href="javascript:;" class="stress" @click="highlightSelectedText">强调显示</a>
              </div>
              <div id="myquestion" ref="myquestion" style="height: calc(100% - 40px);">
                <div class="exam-content">
                  <div v-if="activePart.ExamPartName == '第1部分：知觉速度与准确性'" :style="{ display: isdisplay ? 'flex' : '', 'height': isdisplay ? '100%' : '' }" :class="isdisplay ? 'flex' : ''">
                    <div class="title" :style="{ width: isdisplay ? '50%' : '', 'padding': '20px 0 0 20px', 'height': '100%', 'overflow': 'auto' }"><span v-html="activeEaxm.ExamBigTitleName"></span></div>
                    <div :style="{ 'border-left': isdisplay ? '3px solid #fff' : '', 'width': isdisplay ? '50%' : '', 'height': '100%', 'overflow': 'auto' }">
                      <div class="big-wrap" style="padding:20px 0 0 20px">
                        <div class="big-item" v-for="(item, index) in activeEaxm.ChildExamItemList" :key="index">
                          <div style="margin-bottom: 10px;"><span class="titleNm">{{item.SortNo}}</span>
                            <div class="small-title" v-html="item.Stem"  :id="isdisplay?'id'+ item.SortNo:''"></div>
                          </div>
                          <el-radio-group v-model="item.myanswer" @input="answerChange(item, index)" style="display: flex;align-items: flex-start;">
                            <div v-if="item.OptionA" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="A"></el-radio><span v-if="item.OptionA" style="display: flex;">A.<span style="margin-left: 5px;" v-html="item.OptionA"></span></span></div>
                            <div v-if="item.OptionB" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="B"></el-radio><span v-if="item.OptionB" style="display: flex;">B.<span style="margin-left: 5px;" v-html="item.OptionB"></span></span></div>
                            <div v-if="item.OptionC" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="C"></el-radio><span v-if="item.OptionC" style="display: flex;">C.<span style="margin-left: 5px;" v-html="item.OptionC"></span></span></div>
                            <div v-if="item.OptionD" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="D"></el-radio><span v-if="item.OptionD" style="display: flex;">D.<span style="margin-left: 5px;" v-html="item.OptionD"></span></span></div>
                            <div v-if="item.OptionE" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="E"></el-radio><span v-if="item.OptionE" style="display: flex;">E.<span style="margin-left: 5px;" v-html="item.OptionE"></span></span></div>
                            <div v-if="item.OptionF" style="display: flex;margin-bottom: 10px;margin-right: 10px;"><el-radio label="F"></el-radio><span v-if="item.OptionF" style="display: flex;">F.<span style="margin-left: 5px;" v-html="item.OptionF"></span></span></div>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else :style="{ display: isdisplay ? 'flex' : '', 'height': isdisplay ? '100%' : '' }" :class="isdisplay ? 'flex' : ''">
                    <div v-if="activeEaxm.ExamBigTitleName" class="small-title" v-html="activeEaxm.ExamBigTitleName" :style="{ width: isdisplay ? '50%' : '', 'padding': '20px 0 0 20px', 'height': '100%', 'overflow': 'auto' }"></div>
                    <div :style="{ 'border-left': isdisplay ? '3px solid #fff' : '', 'width': isdisplay ? '50%' : '', 'overflow': 'auto' }">
                      <div class="small-title" v-html="activeEaxm.Stem" :style="{'padding': '20px 0 0 20px', 'overflow': 'auto' }"></div>
                      <div :style="{ 'height': '100%', 'overflow': 'auto' }">
                        <div class="big-wrap" style="padding:20px 0 0 20px">
                          <el-radio-group v-model="activeEaxm.myanswer" @input="answerChange(activeEaxm)" style="display: flex;flex-flow: column nowrap;align-items: flex-start;">
                            <div v-if="activeEaxm.OptionA" style="display: flex;margin-bottom: 10px;"><el-radio label="A"></el-radio><span v-if="activeEaxm.OptionA" style="display: flex;">A.<span style="margin-left: 5px;" v-html="activeEaxm.OptionA"></span></span></div>
                            <div v-if="activeEaxm.OptionB" style="display: flex;margin-bottom: 10px;"><el-radio label="B"></el-radio><span v-if="activeEaxm.OptionB" style="display: flex;">B.<span style="margin-left: 5px;" v-html="activeEaxm.OptionB"></span></span></div>
                            <div v-if="activeEaxm.OptionC" style="display: flex;margin-bottom: 10px;"><el-radio label="C"></el-radio><span v-if="activeEaxm.OptionC" style="display: flex;">C.<span style="margin-left: 5px;" v-html="activeEaxm.OptionC"></span></span></div>
                            <div v-if="activeEaxm.OptionD" style="display: flex;margin-bottom: 10px;"><el-radio label="D"></el-radio><span v-if="activeEaxm.OptionD" style="display: flex;">D.<span style="margin-left: 5px;" v-html="activeEaxm.OptionD"></span></span></div>
                            <div v-if="activeEaxm.OptionE" style="display: flex;margin-bottom: 10px;"><el-radio label="E"></el-radio><span v-if="activeEaxm.OptionE" style="display: flex;">E.<span style="margin-left: 5px;" v-html="activeEaxm.OptionE"></span></span></div>
                            <div v-if="activeEaxm.OptionF" style="display: flex;margin-bottom: 10px;"><el-radio label="F"></el-radio><span v-if="activeEaxm.OptionF" style="display: flex;">F.<span style="margin-left: 5px;" v-html="activeEaxm.OptionF"></span></span></div>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footbtn">
            <div class="drop">
              <input type="button" class="set" @click="nextPlay = true">
              <div class="dropContent" :style="{ 'display': nextPlay ? 'block' : 'none' }">
                <span>
                  <a @click="autoClick(index)" v-for="(item, index) in autoL" :key="index" href="javascript:;" class="ch_auto" :class="item.isclick ? 'select0' : ''">{{ item.name }}</a>
                </span>
                <span>
                  <a @click="scalClick(index)" v-for="(item, index) in scalL" :key="index" href="javascript:;" class="changeBig" :class="item.isclick ? 'select1' : ''">{{ item.name }}</a>
                </span>
              </div>
            </div>
            <input type="button" value="下一题" @click="next" class="next current">
            <input type="button" value="上一题" @click="prev" class="up">
            <input type="button" :value='value' @click="markClick" class="key" :class="value === '标记' ? '' : 'markA'">
          </div>
        </div>
        <div class="choose" id="choose" :style="{ display: showChoose ? 'block' : 'none' }">
          <div class="choContent">
            <p class="tipTit">请选择一个部分进入作答！</p>
            <table id="examPartTable">
              <tbody>
                <tr>
                  <th><span>序号</span></th>
                  <th><span>部分</span></th>
                  <th><span>题数</span></th>
                  <th><span>作答时限</span></th>
                  <th><span>状态</span></th>
                </tr>
                <tr class="change_part" v-for="(item, index) in detailObj.ExamPartList" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td><a href="javascript:;" @click="SelectPart(item)">{{ item.ExamPartName }}</a></td>
                  <td>{{ item.TotalQuestions }}</td>
                  <td>{{ item.ExamTime }}</td>
                  <td>{{ item.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import State from '@/components/State.vue'
export default {
  components: {
    State
  },
  data() {
    return {
      showChoose: false,
      value: '标记',
      atuoNext: false,
      tagL: [],
      account: JSON.parse(sessionStorage.getItem('userInfo')).Account,
      name: JSON.parse(sessionStorage.getItem('userInfo')).Name,
      myanswer: '',
      leftList: [],
      endTime: 10,
      hour: '00',
      minute: '00',
      second: '00',
      et: 0.1,
      h: '00',
      m: '00',
      s: '00',
      ms: 1,
      interval: null,
      ointerval: null,
      partInterval: null,
      msec: 1,
      detailObj: {},
      activePart: {},
      activePartIndex: 0,
      activeEaxm: {},
      activeEaxmIndex: 0,
      countTime: 0,
      showState: false,
      isdisplay: false,
      nextPlay: false,
      isAuto: false,
      autoL: [{ name: '自动切换到下一题', value: 1, isclick: false }, { name: '手动切换到下一题', value: 2, isclick: true }],
      scalL: [{ name: '原始大小', value: 1, isclick: true }, { name: '缩小30%', value: 2, isclick: false }, { name: '放大30%', value: 3, isclick: false }, { name: '放大60%', value: 4, isclick: false }, { name: '放大100%', value: 5, isclick: false }],
      ExamRecordId: ''
    }
  },
  mounted() {
    this.$api.HJStartExam({ paperId: this.$route.query.examID }).then(res => {
      if (res.Success) {
        this.detailObj = res.Data;
        this.detailObj.ExamPartList.sort((a, b) => {
            return a.PartNo - b.PartNo 
          })
        this.detailObj.ExamPartList.map((item, index) => {
          if(item.ExamPartName.indexOf('资料分析')!==-1){
            let arr = [];
            item.ExamItemList.forEach(el=>{
              el.ChildExamItemList.map(it=>{
                this.$set(it,'ExamBigTitleName',el.ExamBigTitleName)
              })
              arr=arr.concat(el.ChildExamItemList)
            })
            this.$set(item,'ExamItemList',arr)
          }
           if (index > 0) {
            //用于跳转下部分activePartIndex的随机选择
            this.tagL.push(index)
          }
          let obj = {
            ExamPartName: item.ExamPartName,
            list: this.convertToObjectArray(item.ExamItemList).flat()
          }
          this.leftList.push(obj)
        })
        this.ExamRecordId = res.Data.ExamRecordId
        this.activePart = this.detailObj.ExamPartList[this.activePartIndex]
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
        this.ExamRecordId = res.Data.ExamRecord.ExamRecordId
        if (this.detailObj.IsForcedReading) {
          this.showState = true;
          this.showChoose = false
          //结束时间
          this.endTime = Date.parse(new Date()) + 120 * 1000;
          //开始倒计时
          this.countdown();
        } else {
          this.endTime = Date.parse(new Date()) + this.detailObj.TotalExamTime * 60 * 1000;
          this.examContdown()
          this.et = Date.parse(new Date()) + this.activePart.ExamTime * 60 * 1000;
          // this.et = Date.parse(new Date()) + 60 * 1000;
          this.partContdown()
          this.leftList[this.activePartIndex].list.map((item, index) => {
            if (index == 0) {
              this.$set(item, 'isclick', true)
            }
          })
        }
      } else this.$message.error(res.Msg)
    })

  },
  beforeDestroy() {
    //提前结束则销毁倒计时
    clearTimeout(this.interval);
    clearTimeout(this.ointerval);
    clearTimeout(this.partInterval);
  },
  methods: {
    skip() {
      this.showState = false;
      this.endTime = Date.parse(new Date()) + 0 * 1000;
      this.countdown();
    },
    //二维转一维
    convertToObjectArray(arr) {
      const result = [];
      for (let i = 0; i < arr.length; i++) {
        const obj = arr[i];
        if (obj.ChildExamItemList.length > 0) {
          const children = this.convertToObjectArray(obj.ChildExamItemList);
          result.push(children);
        } else {
          result.push(obj);
        }
      }
      return result;
    },
    //封装随机选择一个数组中的元素
    randomChoose(arr) {
      if (arr.length > 0) {
        const index = Math.floor(Math.random() * arr.length);
        const selected = arr[index];
        arr.splice(index, 1);
        return selected;
      } else {
        return null;
      }
    },
    //部分倒计时
    partContdown() {
      const end = this.et;
      const now = Date.parse(new Date());
      this.ms = end - now;
      //计算剩余时间
      this.s = (this.ms / 1000) % 60;
      if (this.s < 10) this.s = '0' + this.s
      this.m = parseInt((this.ms / 1000 / 60) % 60);
      if (this.m < 10) this.m = '0' + this.m
      this.h = parseInt(this.ms / 1000 / 60 / 60);
      if (this.h < 10) this.h = '0' + this.h
      const that = this;
      //结束则弹框
      if (this.ms > 0) {
        //进入下一秒倒计时
        this.partInterval = setTimeout(that.partContdown, 1000);
      } else {
        //跳转下部分前，把该部分的点击class清掉
        this.isdisplay=false
        this.leftList[this.activePartIndex].list.map(item => {
          this.$set(item, 'isclick', false)
        })
        this.$set(this.activePart, 'status', '已完成')
        this.$set(this.leftList[this.activePartIndex], 'isanswer', true)
        //随机选择剩下的一个部分
        let nextIndex = this.randomChoose(this.tagL)
        if (nextIndex) {
          this.activePartIndex = nextIndex
          this.activePart = this.detailObj.ExamPartList[this.activePartIndex]
          let arr = []
          this.activePart.ExamItemList.map(item => {
            if (item.ChildExamItemList.length > 0) {
              item.ChildExamItemList.map(it => {
                it.ExamBigTitleName = item.ExamBigTitleName
                arr.push(it)
              })
            }
          })
          this.$set(this.activePart, 'ExamItemList', arr.length > 0 ? arr : this.activePart.ExamItemList)
          this.activeEaxm = this.activePart.ExamItemList[0]
          this.activeEaxmIndex = 0
          this.$confirm(`您将进入 "${this.activePart.ExamPartName}",该部分共${this.activePart.ExamItemList.length}题，作答时限${this.activePart.ExamTime}分钟`, '信息', {
            confirmButtonText: '确定',
            showCancelButton: false,
            customClass: 'del-model',
            type: 'warning'
          }).then(() => { 
            window.location.hash = 'part'+ this.activePartIndex;
          }).catch(error => {
          })
          this.et = Date.parse(new Date()) + this.activePart.ExamTime * 60 * 1000;
          this.partContdown()
        } else {
        }



      }
      if (this.s < 0) {
        this.s = '00'
        this.ms = 0
      }
    },
    //试卷倒计时
    examContdown() {
      const end = this.endTime;
      const now = Date.parse(new Date());
      this.msec = end - now;
      //计算剩余时间
      this.second = (this.msec / 1000) % 60;
      if (this.second < 10) this.second = '0' + this.second
      this.minute = parseInt((this.msec / 1000 / 60) % 60);
      if (this.minute < 10) this.minute = '0' + this.minute
      this.hour = parseInt(this.msec / 1000 / 60 / 60);
      if (this.hour < 10) this.hour = '0' + this.hour
      const that = this;
      //结束则弹框
      if (this.msec > 0) {
        //进入下一秒倒计时
        this.ointerval = setTimeout(that.examContdown, 1000);
      }
      if (this.second < 0) {
        this.second = '00'
        this.msec = 0
      }
    },
    //阅读倒计时
    countdown() {
      //计算运行时间
      const end = this.endTime;
      const now = Date.parse(new Date());
      this.msec = end - now;
      //计算剩余时间
      this.second = (this.msec / 1000) % 60;
      if (this.second < 10) this.second = '0' + this.second
      this.minute = parseInt((this.msec / 1000 / 60) % 60);
      if (this.minute < 10) this.minute = '0' + this.minute
      this.hour = parseInt(this.msec / 1000 / 60 / 60);
      if (this.hour < 10) this.hour = '0' + this.hour
      const that = this;
      //结束则弹框
      if (this.msec > 0) {
        //进入下一秒倒计时
        this.interval = setTimeout(that.countdown, 1000);
      } else {
        this.showState = false
        this.endTime = Date.parse(new Date()) + (this.detailObj.TotalExamTime - 2) * 60 * 1000;
        this.examContdown()

        /**
         * 省时调试区
         */
        this.et = Date.parse(new Date()) + (this.activePart.ExamTime - 2) * 60 * 1000;
        // this.et = Date.parse(new Date()) + 10 * 1000;
        this.partContdown()
        this.leftList[this.activePartIndex].list.map((item, index) => {
            if (index == 0) {
              this.$set(item, 'isclick', true)
            }
          })
      }
      if (this.second < 0) {
        this.second = '00'
        this.msec = 0
      }
    },
    //点击事件答案
    answerChange(item, index) {
      this.value='标记'
      let num = this.leftList[this.activePartIndex].list.findIndex(it => {
        return it.ExamItemId == item.ExamItemId
      })
      this.$set(this.leftList[this.activePartIndex].list[num], 'isanswer', true)
      this.$set(this.leftList[this.activePartIndex].list[num], 'myanswer', item.myanswer)
      // if (this.activeEaxm.ChildExamItemList.length > 0 && this.isAuto) {
      if (this.activeEaxm.ChildExamItemList.length > 0 && this.isAuto) {
        this.$set(this.activeEaxm.ChildExamItemList[index], 'isanswer', true)
        this.leftList[this.activePartIndex].list.map(item => {
          this.$set(item, 'isclick', false)
        })
        this.$set(this.leftList[this.activePartIndex].list[this.activeEaxm.ChildExamItemList[index].SortNo], 'isclick', true)
        if (this.activeEaxm.ChildExamItemList.length == index + 1 && this.activeEaxm.ChildExamItemList[index].SortNo < this.leftList[this.activePartIndex].list.length) {
          this.activeEaxmIndex = this.activeEaxmIndex + 1
          this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
        }
        if(index==9){
          setTimeout(()=>{
          window.location.hash = 'id'+ (item.SortNo+1);
          },10)
        }
      } else {
        this.$set(this.activeEaxm, 'isanswer', true)
        if (this.isAuto) {
          this.next()
          
        }
      }
    },
    //左侧题目选择
    SelectQues(item, index, it,num) {
      if (item.isanswer) {
        this.$confirm('该部分已完成作答，不能再修改?', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => { }).catch(error => {
        })
        return
      }
      if (it.ismark) {
        this.value = '取消标记'
      } else this.value = '标记'
      if (this.activePartIndex === 0 && index !== 0) {
        this.$confirm(`"知觉速度与准确性"答题计时结束才能开始其它部分的作答`, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => { }).catch(error => {
        })
        return
      }
      if (!item.isanswer && index != this.activePartIndex) {
        return
      }
      item.list.map(item => {
        this.$set(item, 'isclick', false)
      })
      this.$set(it, 'isclick', true)
      if (item.ExamPartName.indexOf('知觉速度与准确性') !== -1) {

        let num = this.activePart.ExamItemList.findIndex(i => {
          return i.ExamBigTitleId == it.ExamBigTitleId
        })
        this.activeEaxmIndex = num
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
      }
      else {
        let num = this.activePart.ExamItemList.findIndex(i => {
          return i.ExamItemId == it.ExamItemId
        })
        this.activeEaxmIndex = num
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
      }
      setTimeout(()=>{
       window.location.hash = 'id'+ (num+1);
      },10)
    },
    //下一题
    next() {
      //单题和套题逻辑区分
      let num = ''
      if ( this.activePart.ExamPartName.indexOf('知觉速度与准确性')!==-1) {
        let index = this.activeEaxm.ChildExamItemList.length
        num = this.activeEaxm.ChildExamItemList[index - 1].SortNo
        this.activeEaxmIndex = this.activeEaxmIndex + 1
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
      } else {
        this.activeEaxmIndex = this.activeEaxmIndex + 1;
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
        num = this.activeEaxmIndex
      }
      this.value=this.leftList[this.activePartIndex].list[num]&&this.leftList[this.activePartIndex].list[num].ismark?'取消标记':'标记'
      if (this.activeEaxm) {
        this.leftList[this.activePartIndex].list.map(item => {
          this.$set(item, 'isclick', false)
        })
        this.$set(this.leftList[this.activePartIndex].list[num], 'isclick', true)
      } else {
        this.activeEaxmIndex = this.activeEaxmIndex - 1
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
        this.$confirm('已到该部分最后一题?', '信息', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => { }).catch(error => {
        })
      }
    },
    //上一题
    prev() {
      this.value='标记'
      if (this.activeEaxmIndex > 0) {
        this.activeEaxmIndex = this.activeEaxmIndex - 1
        this.activeEaxm = this.activePart.ExamItemList[this.activeEaxmIndex]
        let num = this.activeEaxm.ChildExamItemList.length > 0 ? this.activeEaxm.ChildExamItemList[0].SortNo : this.activeEaxmIndex
        this.leftList[this.activePartIndex].list.map(item => {
          this.$set(item, 'isclick', false)
        })
        this.$set(this.leftList[this.activePartIndex].list[this.activeEaxm.ChildExamItemList.length > 0 ? num - 1 : num], 'isclick', true)
        let mark = this.activePart.ExamPartName.indexOf('知觉速度与准确性')!==-1?this.leftList[this.activePartIndex].list[num-1].ismark:this.leftList[this.activePartIndex].list[num].ismark
        this.value=mark?'取消标记':'标记'
      } else {
        this.$confirm('已到该部分第一题?', '信息', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {}).catch(error => {})
      }
    },
    //强调显示
    highlightSelectedText() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return;
      const range = selection.getRangeAt(0);
      const span = document.createElement('span');
      span.style.backgroundColor = 'yellow';
      range.surroundContents(span);
    },
    //取消强调显示
    cancelhlightSelectedText() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return;
      const range = selection.getRangeAt(0);
      const node = range.startContainer.parentNode;
      if (node.style.backgroundColor === 'yellow') {
        const content = node.childNodes;
        Array.from(content).forEach(child => {
          node.parentNode.insertBefore(child.cloneNode(true), node);
        });
        node.parentNode.removeChild(node);
      }
      selection.removeAllRanges();
    },
    //是否自动下一题点击
    autoClick(index) {
      this.nextPlay = false
      this.autoL.map(item => {
        this.$set(item, 'isclick', false)
      })
      this.$set(this.autoL[index], 'isclick', true)
      if (index == 0) {
        this.isAuto = true
      } else this.isAuto = false
    },
    //缩放点击
    scalClick(index) {
      this.nextPlay = false
      this.scalL.map(item => {
        this.$set(item, 'isclick', false)
      })
      this.$set(this.scalL[index], 'isclick', true)
      const myquestion = this.$refs.myquestion
      if (index == 0) {
        myquestion.querySelectorAll('*').forEach(element => {
          element.style.fontSize = '16px';
        });
      } else if (index == 1) {
        myquestion.querySelectorAll('*').forEach(element => {
          element.style.fontSize = 16 * 0.7 + 'px';
        });
      } else if (index == 2) {
        myquestion.querySelectorAll('*').forEach(element => {
          element.style.fontSize = 16 * 1.3 + 'px';
        });
      } else if (index == 3) {
        myquestion.querySelectorAll('*').forEach(element => {
          element.style.fontSize = 16 * 1.6 + 'px';
        });
      } else {
        myquestion.querySelectorAll('*').forEach(element => {
          element.style.fontSize = 16 * 2 + 'px';
        });
      }
    },
    //标记
    markClick() {
      let index = this.leftList[this.activePartIndex].list.findIndex(item => {
        return item.isclick
      })
      if (index > -1) {
        if (this.value === '标记') {
          let params = {
            ExamRecordId: this.ExamRecordId,
            ExamPaperId: this.detailObj.ExamPaperId,
            ExamItemId: this.leftList[this.activePartIndex].list[index].ExamItemId
          }
          this.$api.HJAddExamMark(params).then(res => {
            if (res.Success) {

            } else this.$message.error(res.Msg)
          })
          this.$set(this.leftList[this.activePartIndex].list[index], 'ismark', true)
          this.value = '取消标记'
        } else {
          let params = {
            recordId: this.ExamRecordId,
            itemId: this.leftList[this.activePartIndex].list[index].ExamItemId
          }
          this.$api.HJCancelExamMark(params).then(res => {
            if (res.Success) {

            } else this.$message.error(res.Msg)
          })
          this.$set(this.leftList[this.activePartIndex].list[index], 'ismark', false)
          this.value = '标记'
        }
      }
    },
    //开始部分点击
    SelectPart(item) {
      if (item.status == '已完成') {
        return
      } else {
        this.showChoose = false
      }
    },
    //完成本部分测试
    completeClick() {
      this.isdisplay=false;
      var count = this.leftList[this.activePartIndex].list.filter(function (obj) { return obj.isanswer === true; }).length;
      if (count === this.leftList[this.activePartIndex].list.length) {
        this.$confirm(`离开后，${this.activePart.ExamPartName},所有作答结果将不能查看或更改。确认要离开吗？`, '信息', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {
          this.$set(this.leftList[this.activePartIndex], 'isanswer', true)
          this.$set(this.activePart, 'status', '已完成')
          //为了减少部分的时间
          let time=0
              this.tagL.forEach(item=>{
                console.log(this.detailObj.ExamPartList[item].ExamTime)
                time=time+this.detailObj.ExamPartList[item].ExamTime
              })
              this.endTime=Date.parse(new Date()) + time * 60 * 1000;
          let nextIndex = this.randomChoose(this.tagL)
          if (nextIndex) {
            this.activePartIndex = nextIndex
            this.activePart = this.detailObj.ExamPartList[this.activePartIndex]
            let arr = []
            this.activePart.ExamItemList.map(item => {
              if (item.ChildExamItemList.length > 0) {
                item.ChildExamItemList.map(it => {
                  it.ExamBigTitleName = item.ExamBigTitleName
                  arr.push(it)
                })
              }
            })
            this.$set(this.activePart, 'ExamItemList', arr.length > 0 ? arr : this.activePart.ExamItemList)
            this.activeEaxm = this.activePart.ExamItemList[0]
            this.activeEaxmIndex = 0
            this.$confirm(`您将进入 "${this.activePart.ExamPartName}",该部分共${this.activePart.ExamItemList.length}题，作答时限${this.activePart.ExamTime}分钟`, '信息', {
              confirmButtonText: '确定',
              showCancelButton: false,
              customClass: 'del-model',
              type: 'warning'
            }).then(() => { }).catch(error => {
            })
            //为了减少部分的时间
            // this.endTime=this.endTime-this.ms
            // clearTimeout(this.ointerval);
            window.location.hash = 'part'+ this.activePartIndex;
            this.et = Date.parse(new Date()) + this.activePart.ExamTime *60* 1000;
            this.partContdown()
          } else {
            this.showChoose = true
            this.$confirm('当前考试部分作答时间已结束，请尽快进入下一部分作答如果已经全部作答完毕，请交卷', '信息', {
              confirmButtonText: '确定',
              showCancelButton: false,
              customClass: 'del-model',
              type: 'warning'
            }).then(() => { }).catch(error => { })
          }
        }).catch(error => { })
      } else {
        this.$confirm(`${this.leftList[this.activePartIndex].ExamPartName},还有${this.leftList[this.activePartIndex].list.length - count}题未作答。离开后该部分所有作答结果将不能查看或更改。确认要离开吗？`, '信息', {
          confirmButtonText: '确定',
          // showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {
          //修改部分，主要为整个试题的倒计时减少完成部分的时间
          // this.endTime=this.endTime-this.ms
          window.location.hash = 'part'+ this.activePartIndex;
          this.$set(this.leftList[this.activePartIndex], 'isanswer', true)
          this.$set(this.activePart, 'status', '已完成')
          let result = this.detailObj.ExamPartList.every(obj => obj.status);
          if (result) {
            this.showChoose = true
            this.$confirm('当前考试部分作答时间已结束，请尽快进入下一部分作答如果已经全部作答完毕，请交卷', '信息', {
              confirmButtonText: '确定',
              showCancelButton: false,
              customClass: 'del-model',
              type: 'warning'
            }).then(() => { }).catch(error => { })
          } else {
            //修改部分，主要为整个试题的倒计时减少完成部分的时间
            let time=0
              this.tagL.forEach(item=>{
                console.log(this.detailObj.ExamPartList[item].ExamTime)
                time=time+this.detailObj.ExamPartList[item].ExamTime
              })
              this.endTime=Date.parse(new Date()) + time * 60 * 1000;
            let nextIndex = this.randomChoose(this.tagL)
            if (nextIndex) {
              this.activePartIndex = nextIndex
              this.activePart = this.detailObj.ExamPartList[this.activePartIndex]
              let arr = []
              this.activePart.ExamItemList.map(item => {
                if (item.ChildExamItemList.length > 0) {
                  item.ChildExamItemList.map(it => {
                    it.ExamBigTitleName = item.ExamBigTitleName
                    arr.push(it)
                  })
                }
              })
              this.$set(this.activePart, 'ExamItemList', arr.length > 0 ? arr : this.activePart.ExamItemList)
              this.activeEaxm = this.activePart.ExamItemList[0]
              this.activeEaxmIndex = 0
              this.$confirm(`您将进入 "${this.activePart.ExamPartName}",该部分共${this.activePart.ExamItemList.length}题，作答时限${this.activePart.ExamTime}分钟`, '信息', {
                confirmButtonText: '确定',
                showCancelButton: false,
                customClass: 'del-model',
                type: 'warning'
              }).then(() => { }).catch(error => {
              })
              window.location.hash = 'part'+ this.activePartIndex;
              this.examContdown()
              this.et = Date.parse(new Date()) + this.activePart.ExamTime * 60 * 1000;
              this.partContdown()
            } else {
              this.showChoose = true
              this.$confirm('当前考试部分作答时间已结束，请尽快进入下一部分作答如果已经全部作答完毕，请交卷', '信息', {
                confirmButtonText: '确定',
                showCancelButton: false,
                customClass: 'del-model',
                type: 'warning'
              }).then(() => { }).catch(error => { })
            }
          }



        }).catch(error => { })
      }
    },
    //交卷
    comitExam() {
      var count = this.leftList.filter(function (obj) { return obj.isanswer }).length;
      if (count === this.leftList.length) {
        this.showChoose = true
        this.$confirm(`确定交卷?`, '信息', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {
          let arr = [];
          let details = [];
          this.leftList.map(item => {
            arr = arr.concat(item.list)
          })
          arr.map(item => {
            let obj = {
              UserAnswer: item.myanswer,
              ExamItemId: item.ExamItemId,
              ExamRecordId: this.ExamRecordId
            }
            details.push(obj)
          })
          let params = { ExamPaperId: this.detailObj.ExamPaperId, Details: details, ExamRecordId: this.ExamRecordId }
          this.$api.HJAddOrUpdateExamRecord(params).then(res => {
            if (res.Success) {

              clearTimeout(this.partInterval);
              this.$router.push({
                path: '/MySource',
                query: {
                  ExamPaperId: this.detailObj.ExamPaperId,
                  ExamRecordId: this.ExamRecordId
                }
              })
            }
          })
        }).catch(error => { })
      } else {
        if (this.showState) {
          return
        }
        this.$confirm(`还有${this.leftList.length - count}个部分未作答确定交卷?`, '信息', {
          confirmButtonText: '确定',
          showCancelButton: true,
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {
          let arr = [];
          let details = [];
          this.leftList.map(item => {
            arr = arr.concat(item.list)
          })
          arr.map(item => {
            let obj = {
              UserAnswer: item.myanswer || '',
              ExamItemId: item.ExamItemId,
              ExamRecordId: this.ExamRecordId
            }
            details.push(obj)
          })
          let params = { ExamPaperId: this.detailObj.ExamPaperId, Details: details, ExamRecordId: this.ExamRecordId }
          clearTimeout(this.partInterval);
          this.$api.HJAddOrUpdateExamRecord(params).then(res => {
            if (res.Success) {
              clearTimeout(this.partInterval);
              this.$router.push({
                path: '/MySource',
                query: {
                  ExamPaperId: this.detailObj.ExamPaperId,
                  ExamRecordId: this.ExamRecordId
                }
              })
            }
          })
        }).catch(error => { })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.start-exam {
  height: 100%;
  overflow: auto;
  background-color: #edfade !important;

  .examheader {
    background: #0241af;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    zoom: 1;
    float: none;

    .photoHov {
      display: inline-block;
      float: left;
      width: 65px;

      img {
        float: left;
      }
    }

    .perMes {
      margin-left: 8px;
      color: #fff;
      display: inline-block;
      margin-top: 18px;
      float: left;

      label {
        font-size: 16px;
        display: block;
        padding: 5px;
      }
    }

    .tit {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      float: left;
      margin-left: 32px;
      line-height: 32px;
      margin-top: 20px;
    }

    .sub {
      border: none;
      width: 137px;
      height: 46px;
      background-color: #f97217;
      font-size: 20px;
      color: #fff;
      float: right;
      margin-right: 40px;
      margin-top: 20px;
      cursor: pointer;
    }
    .skip{
      background-color: #0241af;
      font-size: 20px;
      color: #fff;
      float: right;
      margin-right: 40px;
      margin-top: 30px;
      cursor: pointer;
      border-bottom:2px solid white
    }

    .timer {
      font-size: 20px;
      color: #fff;
      float: right;
      margin-right: 15px;
      line-height: 30px;
      margin-top: 20px;

      .hourTotal,
      .minuteTotal,
      .secondTotal {
        font-size: 20px;
        margin-right: 5px;
      }
    }
  }

  .exammain {
    margin: 0 auto;
    zoom: 1;
    width: 100%;
    float: none;
    overflow: hidden;
    height: calc(100% - 86px);

    .mainLeft {
      height: 100%;
      min-height: initial;
      padding: 27px 8px;
      border-right: 1px solid #e4e4e4;
      width: 194px;
      float: left;
      padding-bottom: 30px;
      margin-bottom: 0;
      overflow-y: auto;

      .titPart {
        font-size: 16px;
        // background-position: 0 center;
        background-repeat: no-repeat;
        padding-left: 25px;
        line-height: 28px;
        overflow: hidden;
        cursor: pointer;
        background-image: url(../assets/img/jian.png);
        color: #1d7ecc;
        background-position: left 13px;
      }

      a {
        width: 27px;
        height: 27px;
        display: inline-block;
        border: 1px solid #1d7ecc;
        color: #1d7ecc;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        margin-bottom: 10px;
        margin-right: 3px;
        text-decoration: none;
      }
    }

    .mainRight {
      margin-left: 194px;
      border: 1px solid #e4e4e4;
      border-bottom: none;
      height: 100%;

      .myform {
        display: none;
        height: 100%;

        .ti {
          height: calc(100% - 70px);
          overflow: hidden;

          .part {
            padding: 10px;
            color: #353635;
            font-size: 18px;
            overflow: hidden;
            line-height: 27px;

            #mytitle {
              font-size: 16px;
            }

            .completeBtn {
              width: 135px;
              padding-left: 15px;
              height: 27px;
              line-height: 27px;
              float: right;
              padding-right: 10px;
              font-size: 15px;
              background-color: #fff;
              border: 1px solid #1d7ecc;
              margin-left: 10px;
              color: #008dff;
              border-radius: 5px;
              cursor: pointer;
            }

            .mytime2 {
              width: 210px;
              padding-left: 15px;
              height: 27px;
              line-height: 27px;
              float: right;
              padding-right: 10px;
              font-size: 15px;
              background-color: #ffebe0;
              border: 1px solid #f96d42;
            }
          }

          .subject {
            color: #272727;
            border-top: 1px solid #e4e4e4;
            line-height: 27px;
            overflow: hidden;
            overflow-y: auto;
            position: relative;

            .skill {
              position: static;
              border-bottom: 1px solid #cccccc;
              overflow: hidden;
              padding: 10px;
            }

            .skill .row {
              width: 30px;
              display: inline-block;
              background: #e5e5e5 url(../assets/img/two.png) center center
                no-repeat;
            }

            .skill a {
              font-size: 14px;
              float: right;
              margin-left: 15px;
              background: #e5e5e5;
              line-height: 10px;
              vertical-align: middle;
              color: #008dff;
              padding: 5px 10px;
              height: 19px;
              display: inline-block;
              cursor: pointer;
            }

            .skill .NoStress {
              padding-left: 25px;
              background: #e5e5e5 url(../assets/img/qiang.png) 7px center
                no-repeat;
            }

            .skill .stress {
              padding-left: 25px;
              background: #e5e5e5 url(../assets/img/feij.png) 7px center
                no-repeat;
            }

            a {
              text-decoration: none;
            }

            #myquestion {
              overflow: auto;

              .exam-content {
                height: 100%;
                overflow: auto;
                .titleNm {
                  padding-left: 0;
                  display: inline-block;
                  width: 40px;
                  height: 40px;
                  font-size: 15px;
                  color: #000000;
                  text-align: center;
                  line-height: 40px;
                  background: #a7caf0;
                  margin-right: 10px;
                }
                .small-title {
                  display: inline-block;
                }
              }

              ::v-deep p {
                font-size: 16px;
                margin-bottom: 10px;
              }

              ::v-deep span {
                font-size: 16px;
              }

              ::v-deep .el-radio {
                display: flex;
                margin-right: 2px;
              }

              ::v-deep .el-radio__label {
                display: none !important;
              }

              ::v-deep .el-radio__input.is-checked + .el-radio__label {
                display: none;
              }

              ::v-deep .el-radio__label {
                display: flex;
              }

              ::v-deep .el-radio__inner {
                width: 18px;
                height: 18px;
              }

              ::v-deep .dispaly {
                display: flex;
              }

              ::v-deep tr td {
                border: 1px solid #b3b3b3 !important;
                white-space: nowrap;
                text-align: center;
              }

              ::v-deep table {
                margin-top: 10px;
                border: 1px solid #000000;
                border-collapse: collapse;
              }
            }
          }
        }

        .footbtn {
          padding: 10px 40px 10px 0;
          position: relative;
          border-top: 1px solid #e4e4e4;
          height: 70px;

          .drop {
            width: 47px;
            height: 47px;
            position: relative;
            float: right;
            margin-left: 30px;

            .set {
              width: 47px;
              height: 47px;
              background: url(../assets/img/btn.png) 0 -689px;
            }

            .dropContent {
              background: #f0f0f0 url(../assets/img/sline.png) 35px bottom
                repeat-y;
              bottom: 0px;
              right: 0;
              left: initial;
              top: initial;
              z-index: 999999999999;
              border: none;
              height: 175px;
              width: 198px;
              position: absolute;
              padding-top: 3px;
              // display: none;

              span {
                display: block;
                background: url(../assets/img/line.png) 35px bottom no-repeat;
                margin-right: 0px;

                .ch_auto {
                  color: #000000;
                  text-align: left;
                  display: block;
                  font-size: 14px;
                  padding: 3px 21px;
                  padding-left: 40px;
                }

                .select0 {
                  color: #000000;
                  background: url(../assets/img/choose.png) no-repeat 10px
                    center;
                }

                .changeBig {
                  color: #000000;
                  text-align: left;
                  display: block;
                  font-size: 14px;
                  padding: 3px 21px;
                  padding-left: 40px;
                }

                .select1 {
                  color: #000000;
                  background: url(../assets/img/qiu.png) no-repeat 10px center;
                }
              }
            }
          }

          input {
            background-image: url(../assets/img/btn.png);
            background-repeat: no-repeat;
            display: inline-block;
            border: none;
            cursor: pointer;
            float: right;
            margin-right: 30px;
            width: 137px;
            height: 47px;
            background-color: #fff;
          }

          .current {
            background-position: 0 -63px;
            background-color: none;
            color: #fff;
          }

          .up {
            color: #1d7ecc;
            background-position: 0 -125px;
          }

          .key {
            background: none;
            color: #f97217;
            background-color: #fff;
            border: 1px solid #f97217;
            border-radius: 6px;
          }

          .markA {
            color: #fff;
            background-color: #f97217;
          }
        }
      }

      .choose {
        position: relative;

        .tipTit {
          font-size: 40px;
          color: #f97217;
          font-weight: bold;
          text-align: center;
          margin: 100px auto 0;
        }

        table {
          width: 650px;
          margin: 50px auto;
          border-collapse: collapse;
          border-spacing: 0;
        }

        th {
          color: #17b7f2;
          background: #e6e6e6;
          font-weight: 600;
          border: 1px solid #d7d7d7;
          padding: 18px 0;
          text-align: center;
          font-size: 14px;
        }

        .change_part {
          cursor: pointer;

          td {
            text-align: center;
            color: #000000;
            background: #fdf8f8;
            cursor: default;
            line-height: 30px;
            font-size: 16px;
            font-weight: bold;
            padding: 5px 0;
            border: 1px solid #d7d7d7;

            a {
              display: block;
              cursor: pointer;
              color: #17b7f2;
            }
          }
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }

  .blue {
    background-color: #1d7ecc;
    color: #fff !important;
  }

  .yellow {
    background-color: #f97217;
    border-color: #f97217 !important;
    color: #fff !important;
  }

  .mark {
    background-image: url(../assets/img/btn.png);
    background-position: 15px -631px;
    background-repeat: no-repeat;
    z-index: 999;
  }
}
</style>